import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const WalletContext = createContext(null);
export const useWallet = () => useContext(WalletContext);

export function WalletProvider({ children }) {
  const { user, subscribe } = useAuth();
  const [balance, setBalance] = useState(null);

  const refresh = useCallback(async () => {
    if (!user) { setBalance(null); return; }
    try {
      const { data } = await api.wallet();
      setBalance(Math.round(data.balance * 100) / 100);
    } catch { /* ignore */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    if (!user) return;
    return subscribe((msg) => {
      if (msg.type === "billing_tick" && typeof msg.balance === "number") {
        setBalance(Math.round(msg.balance * 100) / 100);
      }
      if (msg.type === "session_ended") refresh();
    });
  }, [user, subscribe, refresh]);

  return (
    <WalletContext.Provider value={{ balance, setBalance, refresh }}>
      {children}
    </WalletContext.Provider>
  );
}
